/** Hint text that does not assume a country. */
export const PHONE_PLACEHOLDER = 'Phone, with country code';
